/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualSaleDto } from '../../models/backend-actual-sale-dto';
import { BackendActualSaleRequestDto } from '../../models/backend-actual-sale-request-dto';

export interface MonitoringActualsSalesCreate$Params {
  /**
   * ID сценария для фильтрации списка
   */
  scenario_id?: number;

  /**
   * Поиск по текстовым полям сущности
   */
  search?: string;
  body: BackendActualSaleRequestDto;
}

export function monitoringActualsSalesCreate(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsSalesCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualSaleDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsSalesCreate.PATH, 'post');
  if (params) {
    rb.query('scenario_id', params.scenario_id, {});
    rb.query('search', params.search, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualSaleDto>;
    }),
  );
}

monitoringActualsSalesCreate.PATH = '/api/monitoring/actuals/sales/';
